(() => {
    if (window.productLoyaltyPointsInitialized) return;

    window.productLoyaltyPointsInitialized = true;
    const selector = '.product-loyalty-points';
    const mobileMedia = window.matchMedia('(max-width: 1023px)');

    document.addEventListener('click', (event) => {
      if (!mobileMedia.matches) return;

      document.querySelectorAll(`${selector}[open]`).forEach((details) => {
        if (!details.contains(event.target)) details.removeAttribute('open');
      });
    });

    document.addEventListener('pointerover', (event) => {
      if (mobileMedia.matches) return;

      event.target.closest(selector)?.setAttribute('open', '');
    });

    document.addEventListener('pointerout', (event) => {
      if (mobileMedia.matches) return;

      const details = event.target.closest(selector);
      if (details && !details.contains(event.relatedTarget)) details.removeAttribute('open');
    });
  })();
